import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgram/OrderApi";
import store from "../../../../Frontends/Common/store";

export class OrderService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editOrder", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editOrder");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getOrders", args);
  }
  async getById(id) {
    return await this.transformer.getGridPanel(this.Api, "getOrderById", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createOrder", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteOrder", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editOrder", model);
  }
  async import(gfid) {
    const res = this.Api.import(gfid);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getImportScaffold() {
    return await this.Api.getImportScaffold();
  }
  async export(filter, format) {
    const res = this.Api.export(filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async publish(marsPeriodId) {
    return await this.Api.publish(marsPeriodId);
  }
  async approve(marsPeriodId) {
    return await this.Api.approve(marsPeriodId);
  }
  async confirm(marsPeriodId) {
    return await this.Api.confirm(marsPeriodId);
  }
  async confirmFactBudget(marsPeriodId) {
    return await this.Api.confirmFactBudget(marsPeriodId);
  }
  async get(marsPeriodId) {
    return await this.Api.getOrder(marsPeriodId);
  }
  async checkPublish(marsPeriodId) {
    return await this.Api.checkPublish(marsPeriodId);
  }
}
